<template>
  <div class="login-card reset">
    <div class="top-operate">
      <el-button type="text" class="back-button" @click="onGoBack">
        返回
      </el-button>
    </div>
    <div class="title default reset-title">设置新密码</div>
    <el-form
      ref="resetForm"
      :rules="resetFormRules"
      :model="resetForm"
      class="form reset-form"
    >
      <!-- 密码 -->
      <el-form-item prop="password">
        <el-input
          v-model.trim="resetForm.password"
          placeholder="请输入密码"
          size="medium"
          show-password
          class="height-input"
        >
          <i slot="prefix" class="icon iconfont icon-mima"></i>
        </el-input>
      </el-form-item>
      <!-- 再次输入密码 -->
      <el-form-item prop="confirmPassword">
        <el-input
          v-model.trim="resetForm.confirmPassword"
          placeholder="请再次输入密码"
          size="medium"
          show-password
          class="height-input"
          @keyup.enter.native="onReset"
        >
          <i slot="prefix" class="icon iconfont icon-yanzhengma"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <!-- 重置密码提示 -->
    <div class="reset-help">
      <span
        class="tip-info"
      >新密码需介于6-14个字母和数字且必须包含大小写字母和数字</span>
    </div>
    <el-button
      class="one-line"
      :loading="loading"
      type="primary"
      size="medium"
      @click="onReset"
    >
      完成
    </el-button>
  </div>
</template>

<script>
import { forgetPasswordUpdateApi } from '@/api/user.js'
import { passwordRegularValid } from '@/utils/form-valid'

export default {
  name: 'Reset',
  data() {
    return {
      resetForm: {
        sign: this.$route.query.sign,
        password: '', // 新密码
        confirmPassword: '' // 再次确认新密码
      },
      resetFormRules: {
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: ['blur', 'change']
          },
          passwordRegularValid
        ],
        confirmPassword: [
          {
            validator: this.validateConfirmPassword,
            trigger: 'blur'
          }
        ]
      },
      loading: false
    }
  },

  beforeRouteEnter(to, form, next) {
    if (to.query.sign) {
      next()
    } else {
      next({ name: 'Login' })
    }
  },

  methods: {
    onGoBack() {
      this.$router.back()
    },
    // 再次输入密码校验
    validateConfirmPassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.resetForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    onReset() {
      this.$refs.resetForm.validate(valid => {
        if (!valid) return

        this.loading = true
        forgetPasswordUpdateApi(this.resetForm)
          .then(res => {
            this.loading = false
            this.$message.success('重置密码成功，请重新登录')
            this.$router.back()
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.data.message)
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.reset {
  padding: pixel-to-rem($n: 90) pixel-to-rem($n: 76) !important;

  .reset-help {
    margin: pixel-to-rem($n: 30) 0;
    font-size: pixel-to-rem($n: 14);
    color: $primary-color;
  }
}
</style>
